module.exports = __webpack_public_path__ + "static/media/inReturnForArrow.c0986d17.svg";